import { useEffect } from 'react';
import type { PublicClinicView } from '@leoclinic/types';

function setNamedMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Título e metadados do browser/PWA com base no perfil público da clínica */
export function useClinicDocumentMeta(clinic: PublicClinicView | null) {
  useEffect(() => {
    if (!clinic) return;

    const title = `${clinic.name} — Marcação Online`;
    document.title = title;
    setNamedMeta('description', `${clinic.name} — ${clinic.profile.tagline ?? 'Marcação online'}`);
    setNamedMeta('apple-mobile-web-app-title', clinic.name);
  }, [clinic]);
}
